

















































import Vue from 'vue';
// import Auth from '@aws-amplify/auth';
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify'

export default Vue.extend({
  name: 'SignIn',

  props: {
    signInConfig: {
      type: Object,
    }
  },
  data() {
    return {
      valid: true,
      password: '',
      showPassword: false,
      logger: {},
      error: '',
      signInUsername: '',
      emailRules: [
        (v: any) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: {
        required: (value: any) => !!value || 'Required.',
        min: (v: string | any[]) => v.length >= 6 || 'Min 6 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      }
    }
  },
  computed: {
    options(): any {
      const defaults = {
        username: ''
      };
      return Object.assign(defaults, this.signInConfig || {})
    },
  },
  mounted() {
  },

  methods: {
    signIn(event: any) {
      this.error = ''
      if (!this.validate()) {
        return;
      }
      Auth.signIn(this.signInUsername.toLowerCase(), this.password)
        .then((data: any) => {
          if (data.challengeName === 'SMS_MFA' || data.challengeName === 'SOFTWARE_TOKEN_MFA') {
            AmplifyEventBus.$emit('localUser', data);
            return AmplifyEventBus.$emit('authState', 'confirmSignIn')
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            AmplifyEventBus.$emit('localUser', data);
            return AmplifyEventBus.$emit('authState', 'requireNewPassword');
          } else if (data.challengeName === 'MFA_SETUP') {
            AmplifyEventBus.$emit('localUser', data);
            return AmplifyEventBus.$emit('authState', 'setMfa');
          } else if (data.challengeName === 'CUSTOM_CHALLENGE' &&
            data.challengeParam &&
            data.challengeParam.trigger === 'true'
          ) {
            AmplifyEventBus.$emit('localUser', data);
            return AmplifyEventBus.$emit('authState', 'customConfirmSignIn')
          } else {
            return AmplifyEventBus.$emit('authState', 'signedIn')
          }
        })
        .catch((e: any) => {
          if (e.code && e.code === 'UserNotConfirmedException') {
            AmplifyEventBus.$emit('localUser', {username: this.signInUsername})
            AmplifyEventBus.$emit('authState', 'confirmSignUp')
          } else {
            this.setError(e);
          }
        });
    },
    validate() {
      return (this.$refs.form as Vue & { validate: () => boolean }).validate();
    },
    forgot() {
      AmplifyEventBus.$emit('authState', 'forgotPassword')
    },
    emailChanged(data: string) {
      this.options.username = data;
    },
    signUp() {
      AmplifyEventBus.$emit('authState', 'signUp')
    },
    setError(e: any) {
      this.error = e.message || e;
    },

  },
});
